import { twdClass } from "../../../constants/tailwind.constants";
import { INPUT_TEXT, BTN_CLS } from "../../../constants/var.constants";
import { getSheetInfo, getSheetColumns } from "../../../api/services";
import { processParamValues } from "../../../utils/common.utils";
import PagesGoogleParams from "../pages/PagesGoogleParams";
import { cloneDeep, find, merge } from "lodash";
import CustomSelectBox from "../../common/CustomSelectBox";
import { toast } from "react-toastify";
import {Button} from "../../ui/com_ui";
import JSON_PageDesigns from "../../../jsons_pageDesigns";

import React, { useState, useEffect } from "react";


const AnimatedButton = ({ children, ...props }) => (
  <Button 
  type="default"  color="black" size={"sm"} className={'ml-2 '}  {...props}>
    {children}
  </Button>
);

const Preview = ({preview, setPreview}) => {
  const closePreview = () => setPreview(null);
  return(<div className="preview-modal" onClick={closePreview}>
    <div className="preview-content" onClick={e => e.stopPropagation()} >
      <div className="preview-content-inner" >
        <div  className={twdClass("sticky top-0 right-0 flex justify-end bg-white p-4")} >
          <Button 
          type="default"  color="black" size={"sm"} className={'ml-2'}  
          onClick={closePreview}>
            &times;
          </Button>
        </div>
        <img src={preview.url} alt={preview.label} style={{maxWidth:"1200px",width:"80vw"}} />
        <div className={twdClass("font-semibold mt-4 text-center opacity-50")} >{preview.label}</div>
      </div>
    </div>
  </div>)
}
const PageDesigns = ({ thumbnails = JSON_PageDesigns, loc='popup', hideDesigns=false, onApply }) => {
  const [preview, setPreview] = useState(null);

  const handlePreview = (thumb) => setPreview(thumb);
  const handleSelect = (thumb) => {
    if (onApply) onApply(thumb);
    //alert(`Applied: ${thumb.label}`);
  };
  let cols=4
  let holderS={height:'300px'}
  if(loc=='sidebar'){
    cols=2
    holderS={}
  }
  if(hideDesigns){
    return(<div className={twdClass('text-base bg-blue-100 p-2 rounded-lg mb-2')}>
    <div className={twdClass('font-semibold  mb-2')}>To add a page template with pre-designed sections, you need to clear the existing sections on this page. </div>    
  </div>)
  }
  return (
    <div  className={twdClass("py-6 border-t border-b border-gray-300 bg-gray-100 rounded-2xl overflow-auto px-4 py-4 mb-2")} style={holderS}>    
    <style>{`
        .animated-btn {
          background: linear-gradient(90deg, #6EE7B7 20%, #3B82F6 80%);
          border: none;
          color: #fff;
          padding: 10px 20px;
          margin-top: 8px;
          border-radius: 6px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0,0,0,0.09);
          outline: none;
          transform: scale(1);
          transition: 
            transform 0.16s cubic-bezier(.25,.8,.25,1),
            box-shadow 0.16s cubic-bezier(.25,.8,.25,1),
            background-position 0.27s cubic-bezier(.25,.8,.25,1);
          background-size: 200% 100%;
          background-position: right center;
        }
        .animated-btn:hover,
        .animated-btn:focus {
          transform: scale(1.08);
          box-shadow: 0 6px 20px rgba(59,130,246,0.15);
          background-position: left center;
        }
        .preview-modal {
          position: fixed;
          top: 0; left: 0;
          width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.6);
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .preview-content {
          background: #fff;
          padding: 18px 18px 18px 18px;
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0,0,0,0.18);
          position: relative; 
          max-width: 80%;         
        }
        .preview-content-inner {
          position: relative;
          min-width: 320px;
          max-width: 100%;
          max-height: 80vh; /* changed to 80vh to make it responsive */
          overflow-y: auto;
        }
        .preview-close-btn {
          position: absolute;
          right: 14px; top: 14px;
          background: transparent;
          border: none;
          font-size: 2rem;
          cursor: pointer;
          line-height: 1;
          color: #444;
          transition: color 0.15s;
        }
        .preview-close-btn:hover {
          color: #f43f5e;
        }
        .thumbnail-selected {
          outline: 3px solid #3B82F6;
          outline-offset: 2px;
        }
      `}</style>  
      <div className={twdClass("text-sm text-center font-semibold uppercase mb-4 tracking-wider ")}>Page Designs</div>
      <div className={twdClass(`grid grid-cols-${cols} gap-3 gap-y-6 items-center flex-wrap `)} >
        {thumbnails.map((item) => (
          <div key={item.id} style={{textAlign: "center"}} className={twdClass("group relative flex flex-col gap-2 shadow-md")}>
            <img 
              src={item.thumb} 
              alt={item.label}              
              className={preview?.id === item.id ? "thumbnail-selected" : ""}
              style={{borderRadius:8,objectFit:'cover'}}
            />
            
            <div className={twdClass("bg-black bg-opacity-20 px-2 rounded-xl opacity-0 hover:opacity-100 flex flex-col justify-center gap-2 transition duration-150  items-center absolute top-0 left-0 right-0 bottom-0")}>
              
              <AnimatedButton size={'xs'} color={'black'} onClick={() => handlePreview(item)}>Preview</AnimatedButton>
              <AnimatedButton size={'xs'} color={'white'} onClick={() => handleSelect(item)} style={{marginLeft:8}}>Select</AnimatedButton>
              <div className={twdClass("text-white text-xs text-center opacity-50 mt-4")}>{item.label}</div>
            </div>
          </div>
        ))}
      </div>
      {preview && <Preview {...{preview, setPreview}}/>}
    </div>
  );
};

export default PageDesigns;